import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { isEqual } from 'lodash-es';
import { Observable, of } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';

import { IdentifierService } from '../../features/identifier/services/identifier.service';
import { reportEffectError } from '../../features/shared/utils/report-effect-error';
import { RootState } from '../root-state.model';
import { IdentifierActions } from './identifier.actions';

@Injectable()
export class IdentifierEffects {
  private service = inject(IdentifierService);
  private actions$ = inject(Actions);
  private readonly store = inject<Store<RootState>>(Store);

  searchEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(IdentifierActions.Search),
      withLatestFrom(this.store),
      switchMap(([action, store]) =>
        isEqual(action.list, store.identifier.identifiers)
          ? of(
              IdentifierActions.SearchSuccess({
                result: store.identifier.searchResult,
                list: action.list,
              })
            )
          : this.service.searchByIdentifiers(action.list).pipe(
              map((result) => IdentifierActions.SearchSuccess({ result, list: action.list })),
              reportEffectError(IdentifierActions.SearchFail)
            )
      )
    )
  );
}
